import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'business-order-film-inventory',
    templateUrl: './business-order-film-inventory.component.html',
    styleUrls: ['./business-order-film-inventory.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BusinessOrderFilmInventoryComponent {
  @Input() filmInventory: number;
  constructor() {
  }

}
